import { useEffect, useRef, useState } from "react";
import { Play, Square, RotateCcw } from "lucide-react";

export const ShotTimer = ({ shot, onDone, postId }) => {
  const total = Math.max(1, Math.round((shot.end ?? 0) - (shot.start ?? 0)) || 3);
  const [left, setLeft] = useState(total);
  const [running, setRunning] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!running) return;
    ref.current = setInterval(() => setLeft((l) => {
      if (l <= 1) { clearInterval(ref.current); setRunning(false); navigator.vibrate?.([200, 100, 200]); onDone?.(); return 0; }
      return l - 1;
    }), 1000);
    return () => clearInterval(ref.current);
  }, [running, onDone]);

  const start = () => { if (left === 0) setLeft(total); setRunning(true); navigator.vibrate?.(80); };
  const stop = () => { clearInterval(ref.current); setRunning(false); };
  const reset = () => { stop(); setLeft(total); };
  const pct = ((total - left) / total) * 100;

  return (
    <div className="mt-2 flex items-center gap-3" data-testid={`shot-timer-${postId}-${shot.n}`}>
      <button onClick={running ? stop : start} className={`h-12 w-12 rounded-full grid place-items-center text-white shrink-0 ${running ? "bg-red-600" : "bg-slate-900"}`} data-testid={`shot-timer-toggle-${postId}-${shot.n}`} aria-label={running ? "Arrêter" : "Lancer le compte à rebours"}>
        {running ? <Square className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
      <div className="flex-1">
        <div className="flex items-baseline justify-between"><span className={`font-heading text-3xl font-extrabold tabular-nums ${left <= 1 && running ? "text-red-600" : "text-slate-800"}`} data-testid={`shot-timer-left-${postId}-${shot.n}`}>{left}<span className="text-sm font-normal text-slate-400"> s</span></span><span className="text-[11px] text-slate-400">durée conseillée {total} s</span></div>
        <div className="h-2 rounded-full bg-slate-200 overflow-hidden"><div className="h-full bg-emerald-500 transition-[width] duration-1000 ease-linear" style={{ width: `${pct}%` }} /></div>
      </div>
      <button onClick={reset} className="text-slate-400 hover:text-slate-700" data-testid={`shot-timer-reset-${postId}-${shot.n}`} aria-label="Réinitialiser"><RotateCcw className="w-4 h-4" /></button>
    </div>
  );
};
